// extracted by mini-css-extract-plugin
export default {"root":"vglAdDXx9pCPoeF9cBDL","dropdown":"fwW87xQD_0VG8ejR6MDP","btns":"NUuGYnWExFjDzLuVsBur"};